import { Component } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MatTableDataSource } from "@angular/material/table";
import { ToastrService } from 'src/app/Service/Common/toastr.service';
import { Subscription } from "rxjs";
import { Constant } from "src/app/Common/constant";
import { LocalStorageService } from "src/app/Model/Common/LocalStorageService";
import { APIFactoryEndPoints } from "src/app/Model/Common/apifactory-end-points";
import { ErrorLog } from "src/app/Model/Common/error-log";
import { RatingsDto } from "src/app/Model/Ratings/ratings-dto";
import moment from "moment";
import { ShippingManagerService } from "src/app/Service/Shipping/shipping-manager.service";
import { HttpErrorResponse } from "@angular/common/http";


@Component({
  selector: 'app-ratings',
  templateUrl: './ratings.component.html',
  styleUrls: ['./ratings.component.css'],
  styles: [`
    .star {
      position: relative;
      display: inline-block;
      font-size: 30px;
      color: #d3d3d3;
    }
    .full {
      color: green;
      font-size: 30px;
    }
    .half {
      position: absolute;
      display: inline-block;
      overflow: hidden;
      color: green;
      font-size: 30px;
    }
  `]
})
export class RatingsComponent {

  createRatingForm: UntypedFormGroup;
  constant: Constant = new Constant();
  errorLog: ErrorLog = new ErrorLog();
  currDate = new Date();

  riderEmail: string;
  // displayedColumns: string[] = ['date', 'ratingby' ,'transactionNo', 'ratingsValue'];
  displayedColumns: string[] = ['byCustomer', 'byLocation'];

  dataSource: MatTableDataSource<RatingsDto>;
  summaryData: RatingsDto[] = [];

  rateByCustomer: number = 0;
  rateByLocation: number = 0;

  private getRiderRatingsSubscription: Subscription;
  private insertErrorLogSubscription: Subscription;


  constructor(
    private apiUrl: APIFactoryEndPoints,
    public persistenceService: LocalStorageService,
    private toastService: ToastrService,
    private formBuilder: UntypedFormBuilder,
    private shippingManagerService: ShippingManagerService,

  ) {
    this.riderEmail = JSON.parse(this.persistenceService.get("google_email"));
    this.dataSource = new MatTableDataSource(this.summaryData);
  }

  ngOnInit(): void {
    this.onCreateSetUp();
  }

  ngOnDestroy() {
    if (this.getRiderRatingsSubscription !== undefined)
      this.getRiderRatingsSubscription.unsubscribe();

    if (this.insertErrorLogSubscription !== undefined)
      this.insertErrorLogSubscription.unsubscribe();
  }

  onCreateSetUp() {
    this.createRatingForm = this.formBuilder.group({
      fromDate: [new Date(), Validators.required],
      toDate: [new Date(), Validators.required]
    })
  }
  onViewClick() {
    if (this.createRatingForm.invalid) {
      this.toastService.showErrorToast(this.constant.invalidFormToast);
      return;
    }
    let momentFromDate = new Date(this.createRatingForm.get('fromDate').value);
    let formattedFromDate = moment(momentFromDate).format("yyyy-MM-DD 00:00:00");

    let momentToDate = new Date(this.createRatingForm.get('toDate').value);
    let formattedToDate = moment(momentToDate).format("yyyy-MM-DD 23:59:59");

    this.getRiderRatingsSubscription = this.shippingManagerService.getRiderRatingData(this.apiUrl.getRiderRatingByEmail, this.riderEmail, formattedFromDate, formattedToDate).subscribe((data) => {

      let rating: RatingsDto = new RatingsDto();
      rating.avgRatingByCustomer = 0;
      rating.avgRatingByLocation = 0;
      if (data.length > 0) {
        let totalRateByCustomer = 0;
        data.forEach(e => totalRateByCustomer += e.toDeliveryBoy);
        rating.avgRatingByCustomer = totalRateByCustomer / data.length;
      }
      else {
        this.toastService.showErrorToast(this.constant.noDataAvailableToast);
      }
      this.dataSource.data = [rating];
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("onViewClick", error);
      });
  }

  insertErrorLog(errorMethod: string, error: HttpErrorResponse) {
    this.errorLog.userId = this.persistenceService.get('userId');
    this.errorLog.dateAndTime = moment(new Date()).format(this.constant.dateTimeFormatForDBServer);
    this.errorLog.moduleName = "Rider Rating Report";
    this.errorLog.errorMethod = errorMethod;
    this.errorLog.platform = "Web";
    if (error?.error?.message || error?.error?.message != '')
      this.errorLog.errorDetails = error.error.message;
    else
      this.errorLog.errorDetails = error.message;

    // this.insertErrorLogSubscription = this.containerService.insertErrorLog(this.apiUrl.insertErrorLog, this.errorLog).subscribe((data: any) => {
    // });
  }
}
